define.alias("shared/components/shared/profile-categorization/icons", "preview-grid/components/shared/profile-categorization/icons");